const TRUTHY = {
    no: 'No',
    yes: 'Yes'
};
const TYPES_OF_ENTITY = {
    Corporation: 'Corporation',
    Partnership: 'Partnership',
    'Sole Proprietor': 'Sole Proprietor',
    LTD: 'LTD',
    LLC: 'LLC',
    Other: 'Other'
};
const POSSIBLE_STATES = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Quebec',
    SK: 'Saskatchewan',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    YT: 'Yukon Territory'
};
const BUSINESS_STRUCTURES = {
    Franchise: 'Franchise',
    Other: 'Other'
};
const BUSINESS_TYPES = {
    Retail: 'Retail',
    Wholesale: 'Wholesale',
    Service: 'Service',
    Lodging: 'Lodging',
    Manufacturing: 'Manufacturing',
    Healthcare: 'Healthcare',
    Other: 'Other'
};
const LEASE_OPTIONS = {
    Lease: 'Lease',
    Own: 'Own'
};

const CREDIT_SCORE = {
    Excellent: 'Excellent 740 - 850',
    Good: 'Good 680 - 739',
    Fair: 'Fair 620 - 679',
    Poor: 'Poor 550 - 619',
    Bad: 'Bad 300 - 549'
};
const AVERAGE_MONTHLY_SALES = {
    'Startup Funding - FICO 700+': 'Startup Funding - FICO 700+',
    '$5000 - $10000': '$5,000 - $10,000',
    '$10001 - $20000': '$10,001 - $20,000',
    '$20001 - $50000': '$20,001 - $50,000',
    '$50001 - $100000': '$50,001 - $100,000',
    '$100001 +': '$100001 +'
};

export const fields = {
    biz_fields: {
        loan_amount: {
            rules: 'required|numeric|max_value:9999999',
            label: 'Requested Amount'
        },
        loan_intent: {
            rules: 'required|max:100',
            label: 'Use of Funds'
        },
        business_legal_name: {
            rules: 'required|max:100',
            label: 'Business Name'
        },
        business_dba: {
            rules: 'required|max:100',
            label: 'Business DBA'
        },
        type_of_entity: {
            rules: `required|included:${Object.keys(TYPES_OF_ENTITY).join(',')}`,
            label: 'Type of Entity',
            options: TYPES_OF_ENTITY
        },
        state_of_incorporation: {
            rules: `required|included:${Object.keys(POSSIBLE_STATES).join(',')}`,
            label: 'Province of Incorporation',
            options: POSSIBLE_STATES
        },
        date_established: {
            rules: 'required|date',
            label: 'Date Established'
        },
        business_id: {
            rules: 'required|max:9',
            label: 'Business ID # (9 Digits) [followed by RT 0001]'
        },
        num_locations: {
            rules: 'required|numeric',
            label: 'Number of Locations'
        },
        num_employees: {
            rules: 'required|numeric',
            label: 'Number of Employees'
        },
        business_type: {
            rules: `required|included:${Object.keys(BUSINESS_TYPES).join(',')}`,
            label: 'Business Type',
            options: BUSINESS_TYPES
        },
        ownership_length_years: {
            rules: 'required|numeric|max_value:9999',
            label: 'Time In Business (years)'
        },
        // ownership_length_months: {
        //     rules: 'required|numeric|max_value:9999',
        //     label: 'Time In Business (months)'
        // },
        products_sold: {
            rules: 'required|max:100',
            label: 'Type of Product/Service Sold'
        },
        // peak_sales_month: {
        //     rules: 'required|max:100',
        //     label: 'Peak Sales Month'
        // },
        is_seasonal_business: {
            rules: `required|included:${Object.keys(TRUTHY).join(',')}`,
            label: 'Is This a Seasonal Business?',
            options: TRUTHY
        },
        // payment_processor: {
        //     rules: 'required|max:100',
        //     label: 'Current Merchant Credit Card Processor Name'
        // },
        total_monthly_sales: {
            rules: 'required|numeric|max_value:99999999',
            label: 'Total Monthly Sales (Average)'
        },
        total_monthly_card_sales: {
            rules: 'required|numeric|max_value:99999999',
            label: 'Total Monthly Card Sales (Average)'
        },
        // eod_average_balance: {
        //     rules: 'required|max:9999999',
        //     label: 'Average Bank Balance At End of Day'
        // },
        business_structure: {
            rules: `required|included:${Object.keys(BUSINESS_STRUCTURES).join(',')}`,
            label: 'Business Structure',
            options: BUSINESS_STRUCTURES
        }
        // credit_score: {
        //     rules: `required|included:${Object.keys(CREDIT_SCORE).join(',')}`,
        //     label: 'Credit Score',
        //     options: CREDIT_SCORE
        // }
        // average_monthly_sales: {
        //     rules: `required|included:${Object.keys(AVERAGE_MONTHLY_SALES).join(',')}`,
        //     label: 'Average Monthly Sales',
        //     options: AVERAGE_MONTHLY_SALES
        // }
    },
    biz_addr_fields: {
        business_address: {
            rules: 'required|max:200',
            label: 'Business Address'
        },
        business_city: {
            rules: 'required|max:100',
            label: 'Business City'
        },
        business_state: {
            rules: `required|included:${Object.keys(POSSIBLE_STATES).join(',')}`,
            label: 'Business Province',
            options: POSSIBLE_STATES
        },
        business_postal_code: {
            rules: 'required|max:7',
            label: 'Business Postal Code'
        },
        business_phone: {
            rules: 'required|digits:10',
            label: 'Business Phone'
        },
        business_email: {
            rules: 'required|email',
            label: 'Business Email'
        },
        lease_own: {
            rules: `required|included:${Object.keys(LEASE_OPTIONS).join(',')}`,
            label: 'Lease / Own',
            options: LEASE_OPTIONS
        },
        monthly_rent_mortgage: {
            rules: 'required|numeric|max_value:999999',
            label: 'Monthly Mortgage / Rent Payment'
        }
    },
    other_credit_relationships: {
        outstanding_mca: {
            rules: `required|included:${Object.keys(TRUTHY).join(',')}`,
            label: 'Do you have any open MCA Accounts?',
            options: TRUTHY
        },
        outstanding_mca_lender: {
            rules: 'required_if:outstanding_mca,yes|max:100',
            label: 'If Yes, MCA Funding Company Name'
        },
        outstanding_mca_term: {
            rules: 'required_if:outstanding_mca,yes|max:100',
            label: 'MCA Estimated Term'
        },
        outstanding_mca_balance: {
            rules: 'required_if:outstanding_mca,yes|max_value:99999999',
            label: 'MCA Remittance Balance'
        },
        outstanding_loan: {
            rules: `required|included:${Object.keys(TRUTHY).join(',')}`,
            label: 'Do you have any outstanding loans?',
            options: TRUTHY
        },
        outstanding_loan_lender: {
            rules: 'required_if:outstanding_loan,yes|max:100',
            label: 'If Yes, Lender Name'
        },
        outstanding_loan_term: {
            rules: 'required_if:outstanding_loan,yes|max:100',
            label: 'Loan Repayment Term'
        },
        outstanding_loan_balance: {
            rules: 'required_if:outstanding_loan,yes|numeric|max_value:9999999',
            label: 'Outstanding Loan Balance'
        },
        outstanding_loan_maturity_date: {
            rules: 'required_if:outstanding_loan,yes|date',
            label: 'Loan Maturity Date'
        }
    },
    owner_fields: {
        position: {
            rules: 'required|max:100',
            label: 'Job Title / Position'
        },
        ownership_percentage: {
            rules: 'required|numeric|min_value:1|max_value:100',
            label: 'Ownership Percentage (1-100%)'
        },
        first_name: {
            rules: 'required|max:100',
            label: 'First Name'
        },
        last_name: {
            rules: 'required|max:100',
            label: 'Last Name'
        },
        email: {
            rules: 'required|email',
            label: 'Email Address'
        },
        cell_phone: {
            rules: 'required|digits:10',
            label: 'Cell Phone'
        },
        home_phone: {
            rules: 'digits:10',
            label: 'Home Phone (Optional)'
        },
        ssn: {
            rules: 'numeric',
            label: 'SIN # [9 Digits] (Optional)'
        },
        dob: {
            rules: 'required|date',
            label: 'Date of Birth'
        },
        address: {
            rules: 'required|max:200',
            label: 'Your Address'
        },
        city: {
            rules: 'required|max:100',
            label: 'Your City'
        },
        postal_code: {
            rules: 'required|max:7',
            label: 'Your Postal Code'
        },
        state: {
            rules: `required|included:${Object.keys(POSSIBLE_STATES).join(',')}`,
            label: 'Your Province',
            options: POSSIBLE_STATES
        },
        years_at_address: {
            rules: 'required|numeric|max_value:99',
            label: 'Time at Address (Years)'
        }
        // months_at_address: {
        //     rules: 'required|numeric|max_value:12',
        //     label: 'Time at Address (Months)'
        // },
        // annual_income: {
        //     rules: 'required|numeric|max_value:999999',
        //     label: 'Annual Income'
        // }
    }
};
